// extracted by mini-css-extract-plugin
export default {"gettingStartedDialog":"GettingStartedDialog-module__gettingStartedDialog--aP2TL"};